"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var renderFont = function (type, weight, theme) {
    if (type === void 0) { type = 'base'; }
    if (weight === void 0) { weight = 'normal'; }
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n"])), theme[type].font[weight].family, theme[type].font[weight].weight);
};
exports.default = renderFont;
var templateObject_1;
//# sourceMappingURL=renderFont.js.map